/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React, { useEffect, useRef } from 'react';
import IconBackToTop from 'src/components/Icons/IconBackToTop';
import { Box, Tab, Tabs, Typography } from '@material-ui/core';
import { motion } from 'framer-motion';
import { Button, Heading } from 'src/components/UI';
import { eventMetricsMap, useEventsReporter } from 'src/hooks';
import CouponList from './CouponList';
import styles from './styles.module.scss';

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            className={styles.tabContainer}
        >
            {value === index && children}
        </div>
    );
}

function a11yProps(index: any) {
    return {
        id: `offer-tab-${index}`,
        'aria-controls': `offer-tabpanel-${index}`,
    };
}

function CouponTab(props: any) {
    const {
        available,
        saved,
        redeemed,
        offerActivate,
        isCouponsFetchingError,
        setValue,
        value,
    } = props;
    const offerRef = useRef<any>(null);

    const { analyticsCustomEvent } = useEventsReporter();

    const getTabName = (newValue: number) => {
        switch (newValue) {
            case 0:
                return 'available';
            case 1:
                return 'clipped';
            case 2:
                return 'redeemed';
            default:
                return 'available'; // Or any default value you'd like
        }
    };

    useEffect(() => {
        analyticsCustomEvent(eventMetricsMap.easy_rewards, {
            click_text: 'available',
            element_location: 'coupons navigation',
        });
    }, []);

    const handleChange = (event: React.ChangeEvent<any>, newValue: number) => {
        console.log('🚀 ~ handleChange ~ event:', newValue);
        setValue(newValue);
        const tabName = getTabName(newValue);
        analyticsCustomEvent(eventMetricsMap.easy_rewards, {
            click_text: tabName?.toString()?.toLowerCase(),
            element_location: 'coupons navigation',
        });
    };
    const handleRedirection = () => {
        setValue(0);
    };

    return (
        <div ref={offerRef}>
            <Box sx={{ borderBottom: 4, borderColor: 'divider' }}>
                <Tabs
                    className={styles.tabs}
                    value={value}
                    onChange={handleChange}
                    aria-label="offer tab"
                >
                    <Tab
                        className={styles.tab}
                        aria-label={`AVAILABLE You are viewing ${
                            available?.length ? `(${available?.length})` : 0
                        } available coupons.`}
                        label={`AVAILABLE ${
                            available?.length ? `(${available?.length})` : ''
                        }`}
                        {...a11yProps(0)}
                    />
                    <Tab
                        className={styles.tab}
                        aria-label={`SAVED You are viewing ${
                            saved?.length ? `(${saved?.length})` : 0
                        } saved coupons.`}
                        label={`CLIPPED ${
                            saved?.length ? `(${saved?.length})` : ''
                        }`}
                        {...a11yProps(1)}
                    />
                    <Tab
                        className={styles.tab}
                        aria-label={`REDEEMED You are viewing ${
                            redeemed?.length ? `(${redeemed?.length})` : 0
                        } redeemed coupons.`}
                        label={`REDEEMED ${
                            redeemed?.length ? `(${redeemed?.length})` : ''
                        }`}
                        {...a11yProps(2)}
                    />
                </Tabs>
                <>
                    <TabPanel value={value} index={0}>
                        <CouponList
                            tabName="available"
                            offers={available}
                            offerActivate={(data: any) => offerActivate(data)}
                        />
                        {/* <div>
                            <Button>Weekly ad</Button>
                            <Button>Easy Rewards</Button>
                        </div> */}
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        {isCouponsFetchingError ? (
                            <div className={styles.noCouponsContainer}>
                                <Heading
                                    type="h3"
                                    size={18}
                                    weight="bold"
                                    className={styles.headerSubTitle}
                                    textAlign="textCenter"
                                >
                                    You have no available coupons. Please check
                                    back later.
                                </Heading>
                            </div>
                        ) : (
                            <CouponList
                                tabName="clipped"
                                offers={saved}
                                offerActivate={(data: any) =>
                                    offerActivate(data)
                                }
                                redirection={handleRedirection}
                            />
                        )}
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        {isCouponsFetchingError ? (
                            <div className={styles.noCouponsContainer}>
                                <Heading
                                    type="h3"
                                    size={18}
                                    weight="bold"
                                    className={styles.headerSubTitle}
                                    textAlign="textCenter"
                                >
                                    You have no available coupons. Please check
                                    back later.
                                </Heading>
                            </div>
                        ) : (
                            <CouponList
                                tabName="redeemed"
                                offers={redeemed}
                                offerActivate={(data: any) =>
                                    offerActivate(data)
                                }
                                redirection={handleRedirection}
                            />
                        )}
                    </TabPanel>
                </>
            </Box>
        </div>
    );
}
export default CouponTab;
